module.exports = __webpack_public_path__ + "static/media/03-thumbnail.09c41872.jpg";